import { Injectable } from "@angular/core";
import { IPublicProfileActionService } from "../IPublicProfileActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Observable } from "rxjs";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class PublicProfilePromiseActionService implements IPublicProfileActionService {
  constructor() {}

  abstract savePublicProfile(
    profileName: string,
    layout: string,
    overWriteExisting: boolean,
  ): Promise<CubiqTS.ErrorsImpl | null>;

  /**
   * Switch the profile for the current user to the specified profile. This should result in the
   * user session being immediately terminated on success
   * @param profile
   * @returns
   */
  abstract switchProfile(profile: CubiqTS.PlatformProfileImpl): Promise<void>;
}
